import React, { useEffect, useState } from 'react';
import { Alert, Button, Col, DatePicker, Divider, Icon, Input, message, Row, Select, Table } from 'antd';
import { currencyVND, dateToString, formatCurrency } from '../../../utils';
import * as CommonService from '../../../services/CommonService';
import { INVENTORY_REPORT, PRODUCT_TYPE_ENDPOINT } from '../../../services/endpoint';
import TableCommon from '../../../components/common/table/TableCommon';
import './style.scss';
import moment from 'moment';

const { Option } = Select;

const DEFAULT_PAGE = {
	currentPage: 1,
	perpage: 20
};
const RevenueChart = () => {

	const [ds, setDs] = useState([]);
	const [searchValues, setSearchValues] = useState({});
	const [page, setPage] = useState({
		...DEFAULT_PAGE,
		total: 0
	});
	const [productType, setProductType] = useState([]);
	const [dsTotal, setDdsTotal] = useState([{
		totalInventory: 0,
		totalInventoryValue: 0
	}]);


	const onSearch = async (pageParam = DEFAULT_PAGE) => {
		const param = { ...searchValues, page: pageParam.currentPage - 1, size: pageParam.perpage };
		window.setLoading(true);
		const resp = await CommonService.get(INVENTORY_REPORT, param);
		setDs(resp.data?.contents?.inventoryResponse || []);
		setPage({
			total: resp.data?.totalElements,
			...pageParam
		});
		setDdsTotal([{
			totalInventory: resp.data?.contents?.totalInventory || 0,
			totalInventoryValue: resp.data?.contents?.totalInventoryValue || 0
		}]);
		window.setLoading(false);
	};

	useEffect(() => {
		const init = async () => {
			window.setLoading(true);
			const apiList = [CommonService.get(PRODUCT_TYPE_ENDPOINT, {}), CommonService.get(INVENTORY_REPORT, {
				page: page.currentPage - 1,
				size: page.perpage
			})];
			const resp = Promise.all(apiList);
			const [productTypeRes, reportRes] = await resp;
			setDs(reportRes.data?.contents?.inventoryResponse);
			setDdsTotal([{
				totalInventory: reportRes.data?.contents?.totalInventory || 0,
				totalInventoryValue: reportRes.data?.contents?.totalInventoryValue || 0
			}]);
			setPage({ ...page, total: reportRes.data?.totalElements });
			setProductType(productTypeRes.data?.map(el => ({ label: el.name, value: el.id, ...el })) || []);
		};
		try {
			init();
		} catch (error) {
			message.error('Có lỗi xảy ra');
		} finally {
			window.setLoading(false);
		}
	}, []);

	// useEffect(() => {
	// 	window.setLoading(true);
	// 	CommonService.get(INVENTORY_REPORT, {}).then((res) => {
	// 		console.log('res', res);
	// 		setDs(res.data?.contents?.inventoryResponse || []);
	// 		setPage({
	// 			total: res.data?.totalElements,
	// 			...DEFAULT_PAGE
	// 		});
	// 	}).catch(e => message.error('Có lỗi xảy ra::' + e)).finally(() => window.setLoading(false));
	// }, []);

	const handleChange = (value, key) => {
		searchValues[key] = value;
		setSearchValues({ ...searchValues });
	};

	const columns = [
		{
			title: 'STT',
			dataIndex: 'index',
			width: 60,
			align: 'center',
			render: (text, record, index) => (page.currentPage - 1) * page.perpage + index + 1
		},
		{
			title: 'Phiên bản sản phẩm',
			dataIndex: 'productName',
			width: 200
		},
		{
			title: 'Loại sản phẩm',
			dataIndex: 'productType',
			align: 'center',
			width: 80
		},
		{
			title: 'Mã đơn hàng',
			dataIndex: 'productCode',
			align: 'center',
			width: 80
		},
		{
			title: 'SurfaceCity',
			children: [
				{
					title: 'Tồn kho',
					dataIndex: 'stockQuantity',
					width: 150,
					align: 'center',
					render: (text) => (<span>{formatCurrency(text)}</span>)
				},
				{
					title: 'Giá trị tồn kho',
					dataIndex: 'inventoryValue',
					width: 150,
					align: 'center',
					render: (text) => (<span>{currencyVND(text)}</span>)
				},
				{
					title: 'Giá vốn',
					dataIndex: 'importPrice',
					width: 150,
					align: 'center',
					render: (text) => (<span>{currencyVND(text)}</span>)
				}
			]
		}
	];

	const columnsTotal = [
		{
			title: 'STT',
			dataIndex: 'index',
			width: 60,
			align: 'center',
			render: () => {
				return {
					children: <b>{`Tổng ${page.total || 0} sản phẩm`}</b>,
					props: { colSpan: 4 }
				};
			}
		},
		{
			title: 'Phiên bản sản phẩm',
			dataIndex: 'productName',
			width: 200,
			render: () => ({ props: { colSpan: 0 } })
		},
		{
			title: 'Loại sản phẩm',
			dataIndex: 'productType',
			align: 'center',
			width: 80,
			render: () => ({ props: { colSpan: 0 } })
		},
		{
			title: 'Mã đơn hàng',
			dataIndex: 'productCode',
			align: 'center',
			width: 80,
			render: () => ({ props: { colSpan: 0 } })
		},
		{
			title: 'SurfaceCity',
			children: [
				{
					title: 'Tồn kho',
					dataIndex: 'totalInventory',
					width: 150,
					align: 'center',
					render: (text) => (<b style={{ color: 'red' }}>{text}</b>)
				},
				{
					title: 'Giá trị tồn kho',
					dataIndex: 'totalInventoryValue',
					width: 150,
					align: 'center',
					render: (text) => (<b style={{ color: 'red' }}>{currencyVND(text)}</b>)
				},
				{
					title: 'Giá vốn',
					dataIndex: 'importPrice',
					width: 150,
					align: 'center',
					render: () => ''
				}
			]
		}
	];


	const onEnter = (evt) => {
		if (evt.key === 'Enter') {
			onSearch(DEFAULT_PAGE);
		}
	};

	const handleExport = async () => {
		try {
			window.setLoading(true);
			const response = await CommonService.post(
				`${INVENTORY_REPORT}/export`,
				searchValues,
				{ responseType: 'blob' }
			);

			const blob = new Blob([response], {
				type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
			});

			// Tạo link download
			const url = window.URL.createObjectURL(blob);
			const a = document.createElement('a');
			a.href = url;
			a.download = `Bao_cao_ton_kho_${moment().format('yyyy_MM_dd_HH_mm_ss')}.xlsx`;
			document.body.appendChild(a);
			a.click();

			a.remove();
			window.URL.revokeObjectURL(url);
		} catch (error) {
			console.error('Lỗi khi export file Excel:', error);
			message.error('Xuất file thất bại');
		} finally {
			window.setLoading(false);
		}
	};


	return (<>
			<Row className="mb-10">
				<Col>
					<div>
						<Divider type="vertical" />
						<Icon type="download" />
						<span style={{ color: '#000000d9', margin: '0 5px', cursor: 'pointer' }}
									onClick={handleExport}>Xuất file</span>
						<Divider type="vertical" />
						{/*<Icon type="upload" />*/}
						<b style={{ margin: '0 5px' }}
							 onClick={() => alert('Nhập file')}>Giá trị tồn kho: <span
							style={{ color: 'red' }}>{currencyVND(dsTotal[0].totalInventoryValue)}</span></b>
					</div>
				</Col>
			</Row>
			<Row>
				<div style={{ display: 'flex', gap: 10, marginBottom: 16 }}>
					<Input
						style={{ height: '32px' }}
						placeholder="Tìm kiếm theo mã sản phẩm, tên sản phẩm, IMEI"
						allowClear
						onChange={(value) => handleChange(value.target.value, 'value')}
						onKeyDown={onEnter}
					/>
					<Select
						mode="multiple"
						placeholder="Loại sản phẩm"
						onChange={(value) => handleChange(value, 'productTypeId')}
						style={{ width: '35%' }}
						allowClear
						maxTagCount={1}
						maxTagTextLength={10}
					>
						{productType.map(el => (<Option key={el.id}>{el.name}</Option>))}
					</Select>
					<DatePicker.RangePicker
						allowClear
						placeholder={['Từ ngày', 'Đến ngày']}
						style={{ width: '600px' }}
						onChange={(value) => {
							const arr = value.map(el => dateToString(el, 'YYYY-MM-DD'));
							handleChange(arr[0], 'from');
							handleChange(arr[1], 'to');
						}} />
					<Button type="primary"
									style={{ width: '150px' }}
									onClick={() => onSearch(DEFAULT_PAGE)}>
						Tìm kiếm
					</Button>
				</div>
			</Row>
			<Alert message={<span>Báo cáo đang lọc theo: SurfaceCity</span>} style={{ marginBottom: '10px' }} />
			<TableCommon bordered={true}
									 className={'inventory-report'}
									 page={page}
									 setPage={setPage}
									 datasource={ds}
									 columns={columns}
									 onSearch={onSearch}
									 footer={() => (
										 <div className={'total-footer'}>
											 <Table dataSource={dsTotal}
															bordered={false}
															showHeader={false}
															pagination={false}
															columns={columnsTotal} />
										 </div>
									 )}
			/>
		</>
	);
};

export default RevenueChart;
